import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { getPostAuthRedirectPath } from '../utils/authRedirect';

const Register: React.FC = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberDevice, setRememberDevice] = useState(true);
  const { register, isLoading } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();
  const logoSrc = '/assets/logo.png';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await register(username, email, password, rememberDevice);
      const nextPath = getPostAuthRedirectPath(location.state as any);
      navigate(nextPath, { replace: true });
    } catch {
      // Errors are handled by auth store toast.
    }
  };

  return (
    <div className="rt-auth-shell min-h-[calc(100vh-12rem)] grid items-center py-6">
      <div className="grid gap-6 lg:grid-cols-[1.05fr_0.95fr]">
        <section className="rt-landscape-compact-card rt-panel-strong rounded-3xl p-8">
          <div className="inline-flex items-center rounded-full border border-white/15 bg-white/5 px-3 py-1 text-xs uppercase tracking-[0.2em] text-white/65">
            Claim Your Seat
          </div>
          <h1 className="mt-5 rt-page-title text-4xl font-semibold">Join ReemTeam</h1>
          <p className="mt-3 text-white/70">
            One account unlocks Reem Team Cash cribs, Cash Crown tournaments, wallet tracking, and ticket lanes.
          </p>
          <div className="mt-8 space-y-3 text-sm text-white/70">
            <div className="rt-glass rounded-xl p-3">Run Reem Team Cash cribs, Reem Team Cash tournaments, and Cash Crown tournaments.</div>
            <div className="rt-glass rounded-xl p-3">Track outcomes and wallet movement from one account dashboard.</div>
            <div className="rt-glass rounded-xl p-3">Redeem satellite tickets for Cash Crown tournaments without converting Reem Team Cash to USD.</div>
          </div>
        </section>

        <section className="rt-landscape-compact-card rt-panel-strong rounded-3xl p-8">
          <div className="flex items-center gap-3 mb-6">
            <img src={logoSrc} alt="ReemTeam logo" className="h-10 w-10 object-contain" />
            <div>
              <div className="text-sm uppercase tracking-[0.18em] text-white/55">Authentication</div>
              <div className="rt-page-title text-xl">Create Account</div>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="Username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              placeholder="Choose a display name"
            />
            <Input
              label="Email Address"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="you@example.com"
            />
            <Input
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Create a secure password"
            />
            <label className="flex items-start gap-3 rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white/75">
              <input
                type="checkbox"
                checked={rememberDevice}
                onChange={(e) => setRememberDevice(e.target.checked)}
                className="mt-0.5 h-4 w-4 rounded border-white/20 bg-black/30 text-amber-300 focus:ring-amber-300"
              />
              <span>
                Keep me signed in on this device
                <span className="block text-xs text-white/50">Recommended for personal or trusted devices.</span>
              </span>
            </label>
            <Button type="submit" className="w-full" isLoading={isLoading}>
              Create Account
            </Button>
          </form>

          <p className="mt-6 text-sm text-white/65">
            Already registered?{' '}
            <Link to="/login" state={location.state} className="text-amber-300 hover:text-amber-200">
              Sign in
            </Link>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Register;
